import { websocketFetch } from 'common/websocket-redux';
import { call } from 'redux-saga/effects';

export const fetchUserBenefitTypeSchemas = ({ groupId, userId }) => {
  return call(websocketFetch, 'get_user_benefit_type_schemas', {
    group_id: groupId,
    user_id: userId,
  });
};
